import React, {useState}  from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import axios from "axios";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const ContactForm = () => {
  const [loading, setLoading] = useState(false);
  const baseUrl = process.env.REACT_APP_API;
  // for validation
  const validationSchema = Yup.object().shape({
    firstName: Yup.string().required("First Name is required"),
    lastName: Yup.string().required("Last name is required"),
    sendMessage: Yup.string().required("Please,leave us a message."),
    email: Yup.string()
      .required("Email is required")
      .email("Entered value does not match email format"),
  });

  const formOptions = { resolver: yupResolver(validationSchema) };
  // get functions to build form with useForm() hook
  const { register, handleSubmit, formState } = useForm(formOptions);
  const { errors } = formState;

  function onSubmit(data, e) {
    // display form data on success
    console.log("Message submited: " + JSON.stringify(data));
    setLoading(true);
    axios.post(baseUrl+"/feedback/request",{
      email: data.email,
      title: 'Khách hàng '+data.firstName+' '+data.lastName+' gửi yêu cầu',
      content: data.sendMessage
    }).then((res) => {
      toast("Đã gửi yêu cầu thành công");
      setLoading(false);
      e.target.reset();
    }).catch((err) => {
      toast("Gửi yêu cầu thất bại");
      setLoading(false);
    });
  }

  return (
    <form id="contact-form" onSubmit={handleSubmit(onSubmit)}>
      <div className="messages"></div>
      <div className="row controls">
        <div className="col-md-6">
          <div className="input-group-meta form-group mb-60">
            <label>Họ & tên đệm</label>
            <input
              type="text"
              placeholder="Họ & tên đệm"
              name="firstName"
              {...register("firstName")}
              className={`${errors.firstName ? "is-invalid" : ""}`}
            />
            {errors.firstName && (
              <div className="invalid-feedback">
                {errors.firstName?.message}
              </div>
            )}
          </div>
        </div>
        {/* End .col */}

        <div className="col-md-6">
          <div className="input-group-meta form-group mb-60">
            <label>Tên</label>
            <input
              type="text"
              placeholder="Tên"
              name="lastName"
              {...register("lastName")}
              className={`${errors.lastName ? "is-invalid" : ""}`}
            />
            {errors.lastName && (
              <div className="invalid-feedback">{errors.lastName?.message}</div>
            )}
          </div>
        </div>
        {/* End .col */}

        <div className="col-12">
          <div className="input-group-meta form-group mb-60">
            <label>Địa chỉ email</label>
            <input
              placeholder="Địa chỉ email"
              name="email"
              type="text"
              {...register("email")}
              className={` ${errors.email ? "is-invalid" : ""}`}
            />
            {errors.email && (
              <div className="invalid-feedback">{errors.email?.message}</div>
            )}
          </div>
        </div>
        {/* End .col */}

        <div className="col-12">
          <div className="input-group-meta form-group lg mb-40">
            <label>Nội dung liên hệ</label>
            <textarea
              placeholder="Nhập yêu cầu của Quý khách ở đây ..."
              name="sendMessage"
              type="text"
              {...register("sendMessage")}
              className={`${errors.sendMessage ? "is-invalid" : ""}`}
            ></textarea>
            {errors.sendMessage && (
              <div className="invalid-feedback">
                {errors.sendMessage?.message}
              </div>
            )}
          </div>
        </div>
        {/* End .col */}

        <div className="col-12">
          <button type="submit" className="theme-btn-six">
            Gửi yêu cầu
          </button>
        </div>
        {loading && <div className="text-sm mt-5" style={{color:'#0ea5e9'}}>Vui lòng đợi ...</div>}
        <ToastContainer position="bottom-right"
        autoClose={5000} closeButton={false}/>
        {/* End .col */}
      </div>
    </form>
  );
};

export default ContactForm;
